import { useParams } from "react-router-dom";
import { Loading } from "./loading";
import { Page404 } from "./page404";
import logo from "../assets/cinch-logo.svg";
import { SurveyProvider, useSurveyContext } from "../contexts/SurveyContext";
import { SurveyHeader } from "../components/SurveyHeader";
import { NavigationButtons } from "../components/NavigationButtons";

const SurveyContent = () => {
  const { status, currentQuestion, saveError } = useSurveyContext();

  if (status === "loading") {
    return <Loading />;
  }

  if (status === "not-found") {
    return <Page404 />;
  }

  return (
    <div id="survey">
      <SurveyHeader />
      <div className="footer">
        {currentQuestion && (
          <>
            {saveError && (
              <div className="save-error" role="alert">
                {saveError}
              </div>
            )}
            <NavigationButtons />
          </>
        )}
        <div className="powered">
          powered by{" "}
          <img
            src={logo}
            alt="Cinch"
          />
        </div>
      </div>
    </div>
  );
};

export const Survey = ({ inTestMode = false }) => {
  const { id: inviteID } = useParams();

  return (
    <SurveyProvider inviteID={inviteID} inTestMode={inTestMode}>
      <SurveyContent />
    </SurveyProvider>
  );
};